import styled from "styled-components";

export const BentoBoxWrapper = styled.div<{ height?: string; width?: string }>`
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    border-radius: 16px;
    border: 1px ${(props) => props.theme.colors.default[200]} solid;
    background: ${(props) => props.theme.colors.default[50]};
    overflow: hidden;
    width: 100%;
    ${({ theme }) => theme.breakpoints.md.query} {
        width: 100%;
        height: 100%;
    }
    ${({ theme }) => theme.breakpoints.sm.query} {
        height: fit-content !important;
`;

export const BentoSectionItem = styled.div<{ $flip?: boolean }>`
  height: inherit;
  width: inherit;
  display: flex;
  flex-direction: ${(props) => (props.$flip ? "column-reverse" : "column")};
  justify-content: space-between;
`;

export const BentoSectionItemContent = styled.div`
  display: flex;
  padding: 32px 32px 16px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  text-align: left;
`;

export const BentoSectionItemHeading = styled.h2`
  color: ${(props) => props.theme.colors.default[900]};
  font-size: 24px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.72px;
`;

export const BentoSectionItemSubHeading = styled.p`
  color: ${(props) => props.theme.colors.default[600]};
  font-size: 17px;
  font-weight: 550;
  line-height: 150%;
`;
export const BentoSectionItemLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.colors.primary[600]};
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

export const BentoSectionItemImageContainer = styled.div<{
  $alignRight?: boolean;
}>`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.$alignRight ? "flex-end" : "center")};
`;
